<template>
  <div>
    <RequestDetail :request="license" />
  </div>
</template>

<script>
import RequestDetail from '../components/request/RequestDetail'

export default {
  props: ['license'],
  components: {
    RequestDetail
  },
  created() {
    if(!this.license){
      this.$router.push({
        name: "licenses"
      });
    }
  }
}
</script>

<style <style lang="scss" scoped>

</style>